import { useQuery } from '@tanstack/react-query';
import { getPsychiatryNoteBySessionId } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const useSessionPsychiatryNoteQuery = (sessionId: string, opts?: BaseQueryOpts) => {
  return useQuery([ 'session', sessionId, 'psychiatryNote' ], async () => {
    if (!sessionId) return null;
    const response = await getPsychiatryNoteBySessionId(sessionId);

    return response.data;
  }, opts);
};
